import { render, staticRenderFns } from "./CostumerSelect.vue?vue&type=template&id=0c513c14&ref=costumerSelect"
import script from "./CostumerSelect.vue?vue&type=script&lang=js"
export * from "./CostumerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports